import { privateAxios } from "@/common/api/axios";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { NegotiationProductHistoryData } from "../types/negotiations.type";

type UseNegotiationsHistoriesProps = {
  enabled?: boolean;
  negotiationProductId?: string;
};

export const useNegotiationProductHistories = ({
  enabled,
  negotiationProductId,
}: UseNegotiationsHistoriesProps) => {
  return useQuery<{ data: { data: NegotiationProductHistoryData[] } }, unknown, NegotiationProductHistoryData[]>({
    enabled,
    queryKey: ['negotiationProductsHistories', negotiationProductId],
    queryFn: () => privateAxios.get(`/client/negotiation_products/${negotiationProductId}/histories`),
    select: (data) => data?.data?.data,
    placeholderData: keepPreviousData,
  });
};
